import React from 'react';
import {Container} from '@inlet/react-pixi';
import {MessagePopupData, SystemPopupPropsTypes} from '@gongxigames/framework/slot/types';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {SoundPlayer} from '@gongxigames/framework/slot/services/SoundPlayer';
import {AlignerByScreen, FlexBoxComponent} from '@gongxigames/framework/core/fragments/react';
import {lazyInject} from '@gongxigames/framework/core';
import {MessagePopupTextComponent} from './MessagePopupTextComponent';
import {SystemPopupView} from '../../systemPopupsManager';
import {MessageButtonsComponent} from './MessageButtonsComponent';

const WIDTH = 1456;

const HEIGHT = {
    WITH_BUTTONS: 500,
    WITHOUT_BUTTONS: 400
};

const GAP_BETWEEN_CONTENTS = 100;
const GAP_BETWEEN_BUTTONS = 50;
const CONTENT_PADDING = {
    left: 50,
    right: 50,
    top: 75,
    bottom: 75
};

export class MessagePopupComponent extends React.Component<SystemPopupPropsTypes<MessagePopupData>, any> {
    @lazyInject(DI.SoundPlayer)
    protected soundPlayer!: SoundPlayer;

    protected hasButtons(): boolean {
        return this.props.data.buttons !== undefined && this.props.data.buttons?.length > 0;
    }

    protected getContentHeight(): number {
        return this.hasButtons() ? HEIGHT.WITH_BUTTONS : HEIGHT.WITHOUT_BUTTONS;
    }

    protected onClickClose(): void {
        this.soundPlayer.play('buttonclick');
        this.props.data.closeButton?.onClick();
    }

    public render(): JSX.Element {
        const {title, message = '', buttons = [], closeButton} = this.props.data;
        const TitleComponent = <MessagePopupTextComponent style={'ErrorPopupTitle'} value={title}/>;

        return (
            <AlignerByScreen verticalAlign={'center'} horizontalAlign={'center'}>
                <SystemPopupView
                    title={TitleComponent}
                    height={this.getContentHeight()}
                    closeButtonEnabled={closeButton && closeButton.visible}
                    onClickClose={this.onClickClose.bind(this)}
                >
                    <FlexBoxComponent
                        containerWidth={WIDTH}
                        direction={'column'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        gap={GAP_BETWEEN_CONTENTS}
                        padding={CONTENT_PADDING}
                    >
                        <Container>
                            <MessagePopupTextComponent style={'ErrorPopupMessage'} value={message} />
                        </Container>
                        <MessageButtonsComponent buttons={buttons} gapBetweenButtons={GAP_BETWEEN_BUTTONS}/>
                    </FlexBoxComponent>
                </SystemPopupView>
            </AlignerByScreen>
        );
    }
}
